import { render } from "./lkab.vue?vue&type=template&id=714b39f0&scoped=true"
import script from "./lkab.vue?vue&type=script&lang=js"
export * from "./lkab.vue?vue&type=script&lang=js"

import "./lkab.vue?vue&type=style&index=0&id=714b39f0&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714b39f0"]])

export default __exports__